import { render, staticRenderFns } from "./gotoAction.vue?vue&type=template&id=fb76ba94"
import script from "./gotoAction.vue?vue&type=script&lang=js"
export * from "./gotoAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports